import * as yup from 'yup'

import externalPlatformIntegrationsConstants from 'constants/externalPlatformIntegrations'

const { SEGCOOP_KIND, SMTP_KIND } = externalPlatformIntegrationsConstants

const isNotSegcoop = (platform) => platform !== SEGCOOP_KIND
const isSmtp = (platform) => platform === SMTP_KIND

const schema = ({ isEditing }) =>
  yup.object().shape({
    ...(!isEditing && {
      externalPlatform: yup.string().required(),
    }),
    externalAccount: yup.string().when('externalPlatform', {
      is: isSmtp,
      then: yup.string().email().required(),
      otherwise: yup.string().when('externalPlatform', {
        is: isNotSegcoop,
        then: yup.string().required(),
        otherwise: yup.string().nullable(),
      }),
    }),
    externalKey: yup.string().when('externalPlatform', {
      is: isNotSegcoop,
      then: yup.string().required(),
      otherwise: yup.string().nullable(),
    }),
    externalSecret: yup.string().when('externalPlatform', {
      is: isNotSegcoop,
      then: isEditing ? yup.string().nullable() : yup.string().required(),
      otherwise: yup.string().nullable(),
    }),
    address: yup.string().when('externalPlatform', {
      is: isSmtp,
      then: yup
        .string()
        .required('O endereço do servidor SMTP é obrigatório')
        .domain('O endereço do servidor SMTP deve ser válido'),
      otherwise: yup.string().nullable(),
    }),
    port: yup.mixed().when('externalPlatform', {
      is: isSmtp,
      then: yup
        .number()
        .typeError('A porta deve ser um número')
        .required('A porta é obrigatória')
        .min(1, 'A porta deve ser maior que 0')
        .max(65535, 'A porta deve ser menor ou igual a 65535'),
      otherwise: yup.mixed().nullable(),
    }),
    domain: yup.string().when('externalPlatform', {
      is: isSmtp,
      then: yup.string().nullable().domain(),
      otherwise: yup.string().nullable(),
    }),
    authentication: yup.string().when('externalPlatform', {
      is: isSmtp,
      then: yup
        .string()
        .oneOf(
          ['login', 'plain', 'cram_md5'],
          'Método de autenticação inválido',
        )
        .required('O método de autenticação é obrigatório'),
      otherwise: yup.string().nullable(),
    }),
    throttlePerMinute: yup.string().nullable(),
    throttlePerHour: yup.string().nullable(),
    starttls: yup.boolean(),
    ssl: yup.boolean(),
    pemFile: yup.mixed().nullable(),
    removePemFile: yup.boolean(),
  })

export default schema
